import request from '@/api/request'

// 获取所有小程序
export const getAllList = (params) => {
    return request({
        url: '/acm/adm/miniprogramManage/getAllList',
        method: 'get',
        params
    });
}

// 小程序渠道列表
export const getListPage = (params) => {
    return request({
        url: '/acm/adm/mChannel/getListPage',
        method: 'get',
        params
    });
}

// 添加小程序渠道
export const addMChannel = (data) => {
    return request({
        url: '/acm/adm/mChannel/addMChannel',
        method: 'post',
        data
    });
}

// 修改小程序渠道
export const updateMChannel = (data) => {
    return request({
        url: '/acm/adm/mChannel/updateMChannel',
        method: 'post',
        data
    });
}

// 删除小程序渠道
export const delMChannel = (data) => {
    return request({
        url: '/acm/adm/mChannel/delMChannel',
        method: 'post',
        data
    });
}